import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { ProductOfferMessageDS } from './product-offer-message-ds'
import { ProductOfferMessageLegacy } from './product-offer-message-legacy'

import type { ProductOfferMessageProps } from './product-offer-message.types'

export type { ProductOfferMessageProps }

export const ProductOfferMessage = (props: ProductOfferMessageProps) => {
  if (shouldUseDesignSystem()) {
    return <ProductOfferMessageDS {...props} />
  }
  return <ProductOfferMessageLegacy {...props} />
}

export default ProductOfferMessage
